export default {
    component: 'scb',
    name: 'scb',
    fields: [
      {
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true,
        hidden: true
      },
      {
        name: 'Block ID',
        param: 'block_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> Should always start from ID **"1"**`
      },
      {
        name: 'Inverter Room',
        param: 'inverter_room',
        type: 'number',
        required: true,
        identifier: true,
        description: `> For each block, room id should start from **"1"**`
      },
      {
        name: 'Inverter ID',
        param: 'inverter_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> For each Block-Room, inverter id should start from **"1"**`
      },
      {
        name: 'SCB ID',
        param: 'scb_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> For each block-room-inverter, scb id should start from **"1"**`
      },
      {
        name: 'Device ID',
        param: 'device_id',
        type: 'number',
        required: true,
        identifier: true,
        description: `> For each block, em id should start from **"1"**`
      },
      {
        name: 'SCB Name',
        param: 'scb_name',
        type: 'text',
        description: `> For each inverter device name should be unique`
      },
      {
        name: 'Name Config',
        param: 'name_config',
        type: 'text',
        description: `> The name should be unique. Name Concatination of blockname-roomname-devicename`
      },
      {
        name: 'No Of Channels',
        param: 'no_of_channels',
        type: 'number',
        description: `> Add each SCB how many channels required`
      },
      {
        name: 'Y Connector Status',
        param: 'y_connector_status',
        type: 'number',
      },
      {
        name: 'Reading Frequency',
        param: 'reading_frequency',
        type: 'number',
        description: `> It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
      },
      {
        name: 'Latitude',
        param: 'latitude',
        type: 'number',
        description: `To plot map marker on PlantOverview Map View`
      },
      {
        name: 'Longitude',
        param: 'longitude',
        type: 'number',
        description: `> To plot map marker on PlantOverview Map View`
      },
      {
        name: 'Max Current',
        param: 'max_current',
        type: 'number',
        description: `> By default it should be 1`
      },
      {
        name: 'Make',
        param: 'make',
        type: 'text',
      },
      {
        name: 'Cable Length',
        param: 'cable_length',
        type: 'number',
      },
      {
        name: 'Param Config',
        param: 'param_config',
        type: 'json',
        description: `- **SCB** - [{"current": {"count": 16}, "status1": {"name": "Breaker Status", "method": "AVG"}, "status2": {"name": "SPD Status", "method": "AVG"}, "voltage": {"name": "Voltage", "unit": "V", "method": "AVG"}, "dc_power": {"name": "DC Power", "unit": "kW", "method": "AVG"}, "temperature": {"name": "Temperature", "unit": "°C", "method": "AVG"}}]
        - **String Inverter** - [{"power": {"count": 1, "multiple": false, "nameIndexing": true}, "current": {"count": 12}, "voltage": {"count": 1, "multiple": false, "nameIndexing": true}}]
        - **Adv MPPT** - [{"power": {"count": 14, "multiple": true, "nameIndexing": true}, "current": {"count": 14}, "voltage": {"count": 14, "multiple": true, "nameIndexing": true}}]`
      },
      {
        name: 'Filter Config',
        param: 'filter_config',
        type: 'json',
        description: `> threshold value needs to be added for junk value *\({"validationRules": {"ac_power": {"maxValue": 20, "minValue": 0}, "active_total_export_cumulative": {"cumulative": {"threshold": 5}}}})`
      },
      {
        name: 'Parameter List',
        param: 'param_list',
        type: 'text',
        description: `> In order to remove unwanted parameters from analytics. *\(e.g rm-current,rm-power)`
      },
      {
        name: 'Inverter Type',
        param: 'inverter_type',
        type: 'number',
        description:` - If its SCB - inverter type should be **"1"**
        - If its String Inverter/MPPT - inverter type should be **"2"**
        - If its Zone - inverter type should be **"3"**`
      },
      {
        name: 'Model',
        param: 'model',
        type: 'text',
      },
    ]
  }

 
